export default "__VITE_ASSET__4bd1e09e__"